module.exports = __webpack_public_path__ + "static/img/smartProduct4.4f3c8d30.png";